/* global $ */
/**
 * jQuery library access
 *
 * * In standalone mode (`!__SLAVE__`) and `__JQUERY_LIBRARY__` is defined, use that version
 * * Else if jQuery is bundled (library_source in client.js.jinja2), export $ from bundle. Note in particular that
 *     classic does not have to be "initialized" for this variable to be defined.
 * * Else if `window.jQuery` is defined, export `window.jQuery`
 * * Else if `window.$` is defined, export `window.$`
 *
 * @module
 */
var WindowEnv = require('core/env/window');

if (!__SLAVE__ && __JQUERY_LIBRARY__) {
  if(__EXPERIMENTAL_WEB_SDK__){
    if(__JQUERY_LIBRARY__ === 'jquery-1.6.4-full'){
      module.exports = require('../../vendor/jquery-1.6.4-full');
    } else if(__JQUERY_LIBRARY__ === 'jquery-1.6.4-trim'){
      module.exports = require('../../vendor/jquery-1.6.4-trim');
    } else if(__JQUERY_LIBRARY__ === 'jquery-1.11.3-full'){
      module.exports = require('../../vendor/jquery-1.11.3-full');
    } else if(__JQUERY_LIBRARY__ === 'jquery-1.11.3-trim'){
      module.exports = require('../../vendor/jquery-1.11.3-trim');
    } else if(__JQUERY_LIBRARY__ === 'jquery-2.1.4'){
      module.exports = require('../../vendor/jquery-2.1.4');
    }
  } else {
    module.exports = require(__JQUERY_LIBRARY__);
  }
} else {
  var dollar;
  try {
    dollar = $;  // no-ts-lint
  } catch (e) {
    // ReferenceError means no $ defined in scope
  }

  var window$ = WindowEnv.getGlobal('$');

  if (dollar && dollar !== window$) {
    // $ defined in bundle scope
    module.exports = dollar;
  } else {
    // window.jQuery > window.$
    if (__LEGACY_RESOLVE_WINDOW_JQUERY__) {
      module.exports = WindowEnv.getGlobal('jQuery') || window$;
    } else {
      module.exports = window$;
    }
  }
}
